(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@skype/tsregistrar", [], factory);
	else if(typeof exports === 'object')
		exports["@skype/tsregistrar"] = factory();
	else
		root["@skype/tsregistrar"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timespan = exports.toJson = exports.fetchWithTimeout = void 0;
/** Wrapper to send request with specified timeout */
function fetchWithTimeout(request, timeoutMs) {
    var timeoutId;
    var fetchPromise = new Promise(function (resolve, reject) {
        fetch(request).then(function (response) {
            if (timeoutId !== undefined) {
                clearTimeout(timeoutId);
            }
            resolve(response);
        }).catch(function (error) {
            if (timeoutId !== undefined) {
                clearTimeout(timeoutId);
            }
            reject(error);
        });
    });
    if (timeoutMs !== 0) {
        var timeoutPromise = new Promise(function (resolve, reject) {
            timeoutId = setTimeout(reject, timeoutMs, new Error("Fetch for '".concat(request.url, "' timed out")));
        });
        return Promise.race([fetchPromise, timeoutPromise]);
    }
    return fetchPromise;
}
exports.fetchWithTimeout = fetchWithTimeout;
function toJson(obj) {
    try {
        return JSON.stringify(obj);
    }
    catch (error) {
        return "Unable to serialize object of type ".concat(typeof obj);
    }
}
exports.toJson = toJson;
/**
 * Simplify calculation of time intervals
 */
var Timespan = /** @class */ (function () {
    function Timespan() {
        this.start = Date.now();
    }
    Object.defineProperty(Timespan.prototype, "duration", {
        /**
         * Returns number of milliseconds from start
         */
        get: function () {
            return Date.now() - this.start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Timespan.prototype, "startTime", {
        /**
         * Returns start time
         */
        get: function () {
            return this.start;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Reset start of interval to current timestamp
     */
    Timespan.prototype.reset = function () {
        this.start = Date.now();
    };
    return Timespan;
}());
exports.Timespan = Timespan;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRegistrarClient = exports.RegistrarClient = void 0;
var Common_1 = __webpack_require__(0);
var SUPPORTED_TOKEN_TYPES = ['skype', 'aad', 'cae'];
/**
 * Thrown when retry process was cancelled
 */
var CancelationError = /** @class */ (function (_super) {
    __extends(CancelationError, _super);
    function CancelationError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'CancelationError';
        return _this;
    }
    return CancelationError;
}(Error));
/**
 * Randomized exponential delay used for retries
 */
var ExponentialDelay = /** @class */ (function () {
    function ExponentialDelay(logger, maxBackoffInMs, initialDelay) {
        this.logger = logger;
        this.maxBackoffInMs = maxBackoffInMs;
        this.initialDelay = initialDelay;
        this.backoffCount = 0;
        this.id = ++ExponentialDelay.idCounter;
    }
    ExponentialDelay.prototype.delay = function (taskName) {
        var _this = this;
        if (this.timerHandle !== undefined) {
            throw new Error('Retry sequence logical failure');
        }
        if (this.backoffCount === -1) {
            return new Promise(function (resolve, reject) { reject(new CancelationError('Cancelled')); });
        }
        var backoffMs = this.calculateNextBackoffMs();
        this.backoffCount++;
        this.logger.info("[RegistrarClient] Backing off ".concat(taskName, " for ").concat(backoffMs, " milliseconds with ID ").concat(this.id));
        return new Promise(function (resolve, reject) {
            _this.cancelFunc = reject;
            _this.timerHandle = setTimeout(function () {
                _this.logger.info("[RegistrarClient] Back off for ".concat(taskName, " with ID ").concat(_this.id, " complete"));
                _this.timerHandle = undefined;
                resolve();
            }, backoffMs);
        });
    };
    ExponentialDelay.prototype.cancel = function () {
        if (this.timerHandle !== undefined) {
            this.logger.debug('Resetting back off');
            clearTimeout(this.timerHandle);
            if (this.cancelFunc !== undefined) {
                this.cancelFunc(new CancelationError('Cancelled'));
            }
        }
        this.backoffCount = -1;
    };
    ExponentialDelay.prototype.calculateNextBackoffMs = function () {
        var fudge = 1 + (Math.random() - 0.5) * 0.4; // +/- 20%
        var backoff = this.initialDelay * Math.pow(2, this.backoffCount) * fudge;
        backoff = Math.round(backoff);
        return Math.min(this.maxBackoffInMs, backoff);
    };
    ExponentialDelay.idCounter = 0;
    return ExponentialDelay;
}());
/**
 * Registrar client implementation
 */
var RegistrarClient = /** @class */ (function () {
    function RegistrarClient(logger, tokenProvider, options) {
        var _a;
        this.logger = logger;
        this.tokenProvider = tokenProvider;
        this.options = options;
        this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN = 15;
        // Default value for maximum backoff between retries
        this.DEFAULT_MAX_BACKOFF_TIME_IN_MS = 300000; // 5 minutes
        this.backoffs = {};
        this.maxBackOffTime =
            this.options.maxRetryDelayMs > 0
                ? this.options.maxRetryDelayMs
                : this.DEFAULT_MAX_BACKOFF_TIME_IN_MS;
        this.maxRetriesForGetToken =
            options.maxRetriesForGetToken === undefined ||
                options.maxRetriesForGetToken === null
                ? this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN
                : options.maxRetriesForGetToken;
        this.proxyUrlRewrite = (_a = options.proxyUrlRewrite) !== null && _a !== void 0 ? _a : (function (url) { return url; });
    }
    RegistrarClient.prototype.setTelemetryLogger = function (eventLogger) {
        this.eventLogger = eventLogger;
    };
    RegistrarClient.prototype.register = function (client, transports) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.performRegistration(client, transports, 'pr_set_registration')];
                    case 1:
                        _a.sent();
                        this.cachedRegistrationParams = [client, transports];
                        return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.unregister = function () {
        return __awaiter(this, void 0, void 0, function () {
            var unregisterRequest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info('[RegistrarClient] sending unregister request');
                        unregisterRequest = new Request(this.proxyUrlRewrite("".concat(this.options.registrarUrl, "/").concat(this.options.registrationId)), {
                            method: 'DELETE',
                            mode: 'cors',
                            headers: new Headers(__assign(__assign({}, this.options.extraRegistrationHeaders), { accept: 'application/json, text/javascript' }))
                        });
                        return [4 /*yield*/, this.callRegistrar(unregisterRequest, 'pr_delete_registration')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.cancelPendingRequests = function () {
        var _this = this;
        Object.keys(this.backoffs).forEach(function (id) {
            _this.backoffs[id].cancel();
        });
        this.backoffs = {};
    };
    RegistrarClient.prototype.resendRegistration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.cachedRegistrationParams) {
                            throw new Error('Re-registration failed because there is no registration parameters cached');
                        }
                        return [4 /*yield*/, this.performRegistration(this.cachedRegistrationParams[0], this.cachedRegistrationParams[1], 'pr_resend_registration')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.performRegistration = function (client, transports, eventName) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, registerRequest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info('[RegistrarClient] Sending register request');
                        payload = {
                            clientDescription: client,
                            registrationId: this.options.registrationId,
                            nodeId: '',
                            transports: transports
                        };
                        registerRequest = new Request(this.proxyUrlRewrite(this.options.registrarUrl), {
                            method: 'POST',
                            mode: 'cors',
                            headers: new Headers(__assign(__assign({}, this.options.extraRegistrationHeaders), { 'content-type': 'application/json', accept: 'application/json, text/javascript' })),
                            body: (0, Common_1.toJson)(payload)
                        });
                        return [4 /*yield*/, this.callRegistrar(registerRequest, eventName)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.startBackoff = function () {
        var backoff = new ExponentialDelay(this.logger, this.maxBackOffTime, this.options.initialRetryDelayMs);
        this.backoffs[backoff.id] = backoff;
        return backoff;
    };
    RegistrarClient.prototype.stopBackoff = function (backoff) {
        backoff.cancel();
        delete this.backoffs[backoff.id];
    };
    RegistrarClient.prototype.getToken = function (claimsChallenge) {
        return __awaiter(this, void 0, void 0, function () {
            var backoff, retryCount, token, error_1, stringfiedError, err, cancelError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        backoff = this.startBackoff();
                        retryCount = 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 8]);
                        this.logger.info('[RegistrarClient] Asking for a new token');
                        return [4 /*yield*/, this.tokenProvider({
                                needFresh: true,
                                supportedTokenTypes: SUPPORTED_TOKEN_TYPES,
                                wwwAuthenticateHeader: claimsChallenge,
                                purpose: 'registrar'
                            })];
                    case 2:
                        token = _a.sent();
                        this.stopBackoff(backoff);
                        return [2 /*return*/, token];
                    case 3:
                        error_1 = _a.sent();
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        retryCount++;
                        stringfiedError = JSON.stringify(error_1);
                        if (retryCount > this.maxRetriesForGetToken) {
                            err = "[RegistrarClient] getToken retry limit hit. Will not retry now. Error: ".concat(stringfiedError);
                            this.logger.error(err);
                            this.stopBackoff(backoff);
                            return [2 /*return*/, Promise.reject(err)];
                        }
                        this.logger.warn("[RegistrarClient] Retrying for a new token. Retry Count: ".concat(retryCount, " Error: ").concat(stringfiedError));
                        return [4 /*yield*/, backoff.delay('Fetching a new token')];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        cancelError_1 = _a.sent();
                        this.stopBackoff(backoff);
                        throw cancelError_1;
                    case 7: return [3 /*break*/, 8];
                    case 8: return [3 /*break*/, 1];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.callRegistrar = function (request, eventName) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var backoff, cachedToken, stopwatch, retryCount, response, req, err, claimsChallenge, _d, _e, error_2, canceledError_1, details, _f, _g, error_3, message;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        backoff = this.startBackoff();
                        return [4 /*yield*/, this.tokenProvider({
                                needFresh: false,
                                supportedTokenTypes: SUPPORTED_TOKEN_TYPES,
                                wwwAuthenticateHeader: undefined,
                                purpose: 'registrar'
                            })];
                    case 1:
                        cachedToken = _h.sent();
                        this.setTokenHeader(request, cachedToken);
                        stopwatch = new Common_1.Timespan();
                        retryCount = 0;
                        _h.label = 2;
                    case 2:
                        response = void 0;
                        _h.label = 3;
                    case 3:
                        _h.trys.push([3, 10, 15, 16]);
                        req = request.clone();
                        return [4 /*yield*/, (0, Common_1.fetchWithTimeout)(req, this.options.requestTimeoutMs)];
                    case 4:
                        response = _h.sent();
                        if (!(response.status === 401)) return [3 /*break*/, 8];
                        retryCount++;
                        if (retryCount > this.maxRetriesForGetToken) {
                            err = "[RegistrarClient] getSkypeToken retry limit hit. Will not retry now. Request '".concat(request.url, "' failed with ").concat(response.status, " ").concat(response.statusText);
                            this.logger.error(err);
                            this.stopBackoff(backoff);
                            return [2 /*return*/, Promise.reject(err)];
                        }
                        this.logger.warn("[RegistrarClient] Retry Count ".concat(retryCount, ". Request '").concat(request.url, "' failed with ").concat(response.status, " ").concat(response.statusText));
                        claimsChallenge = (_b = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('www-authenticate')) !== null && _b !== void 0 ? _b : undefined;
                        _d = this.setTokenHeader;
                        _e = [request];
                        return [4 /*yield*/, this.getToken(claimsChallenge)];
                    case 5:
                        _d.apply(this, _e.concat([_h.sent()]));
                        if (!(retryCount > 1)) return [3 /*break*/, 7];
                        // for later retries, e.g. with token revocation, wait until SEAL knows the token was revoked,
                        // so that proper claims challenges are sent, see https://skype.visualstudio.com/SCC/_workitems/edit/3337904/
                        return [4 /*yield*/, backoff.delay('Registrar call retry after 401')];
                    case 6:
                        // for later retries, e.g. with token revocation, wait until SEAL knows the token was revoked,
                        // so that proper claims challenges are sent, see https://skype.visualstudio.com/SCC/_workitems/edit/3337904/
                        _h.sent();
                        _h.label = 7;
                    case 7: return [3 /*break*/, 22];
                    case 8:
                        if (response.status >= 500 && response.status < 600) {
                            // throw and retry after in the catch section
                            throw new Error("Fetch for '".concat(request.url, "' failed with ").concat(response.status, " ").concat(response.statusText));
                        }
                        _h.label = 9;
                    case 9: return [3 /*break*/, 16];
                    case 10:
                        error_2 = _h.sent();
                        this.logger.error("[RegistrarClient] Request failed with ".concat(error_2));
                        _h.label = 11;
                    case 11:
                        _h.trys.push([11, 13, , 14]);
                        // retry on network errors (thrown by fetch) and retryable codes
                        return [4 /*yield*/, backoff.delay('Registrar call retry')];
                    case 12:
                        // retry on network errors (thrown by fetch) and retryable codes
                        _h.sent();
                        return [3 /*break*/, 22];
                    case 13:
                        canceledError_1 = _h.sent();
                        this.logger.error('[RegistrarClient] Request cancelled');
                        this.stopBackoff(backoff);
                        throw canceledError_1;
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        this.sendTelemetryEvent(eventName, request, response, stopwatch);
                        return [7 /*endfinally*/];
                    case 16:
                        this.stopBackoff(backoff);
                        if (!response.ok) return [3 /*break*/, 17];
                        return [2 /*return*/, response];
                    case 17:
                        details = void 0;
                        _h.label = 18;
                    case 18:
                        _h.trys.push([18, 20, , 21]);
                        _g = (_f = JSON).stringify;
                        return [4 /*yield*/, response.json()];
                    case 19:
                        details = _g.apply(_f, [_h.sent()]);
                        return [3 /*break*/, 21];
                    case 20:
                        error_3 = _h.sent();
                        details = 'no details';
                        return [3 /*break*/, 21];
                    case 21:
                        message = "Fetch for '".concat(request.url, "' failed with ").concat(response.status, " ").concat(response.statusText, " (").concat(details, ", MS-CV: ").concat((_c = response.headers) === null || _c === void 0 ? void 0 : _c.get('MS-CV'), ")");
                        this.logger.error("[RegistrarClient] ".concat(message));
                        throw new Error(message);
                    case 22: return [3 /*break*/, 2];
                    case 23: return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.setTokenHeader = function (request, token) {
        // Because a request object is cloned on 401 retries, we need to reset the state to baseline
        request.headers.delete('X-Skypetoken');
        request.headers.delete('Authorization');
        request.headers.delete('X-MS-Migration');
        switch (token.tokenType.toLowerCase()) {
            case 'skype':
                request.headers.set('X-Skypetoken', token.token);
                break;
            case 'aad':
            case 'cae':
                request.headers.set('Authorization', "Bearer ".concat(token.token));
                break;
            default:
                throw new Error("unsupported token type: ".concat(token.tokenType));
        }
        if (this.options.usingLegacyTokenApi === false) {
            request.headers.set('X-MS-Migration', 'True');
        }
    };
    RegistrarClient.prototype.sendTelemetryEvent = function (eventName, request, response, stopwatch) {
        if (this.eventLogger === undefined) {
            return;
        }
        var clientEvent = {
            name: eventName,
            properties: {
                url: { value: request.url },
                result_code: { value: response !== undefined ? response.status : 0 },
                begin_timestamp: { value: stopwatch.startTime },
                elapsed: { value: stopwatch.duration }
            }
        };
        this.eventLogger.logEvent(clientEvent);
    };
    return RegistrarClient;
}());
exports.RegistrarClient = RegistrarClient;
function createRegistrarClient(logProvider, tokenProvider, options) {
    return new RegistrarClient(logProvider, tokenProvider, options);
}
exports.createRegistrarClient = createRegistrarClient;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// tsregistrar.js